module.exports = __webpack_public_path__ + "media/images/menu/lyra-35506cd61a0d6a27fa976bce58888619.jpg";